import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import { LANGUAGE_CODE } from './enums';
import germanDE from './translations/de/germanDE.json';
import englishGB from './translations/en/englishGB.json';
import englishUS from './translations/en/englishUS.json';
import frenchBE from './translations/fr/frenchBE.json';
import frenchFR from './translations/fr/frenchFR.json';
import dutchBE from './translations/nl/dutchBE.json';
import dutchNL from './translations/nl/dutchNL.json';

i18n.use(initReactI18next).init({
  resources: {
    EnglishUS: {
      common: englishUS
    },
    EnglishGB: {
      common: englishGB
    },
    FrenchFR: {
      common: frenchFR
    },
    FrenchBE: {
      common: frenchBE
    },
    DutchBE: {
      common: dutchBE
    },
    DutchNL: {
      common: dutchNL
    },
    GermanDE: {
      common: germanDE
    }
  },
  keySeparator: false,
  interpolation: { escapeValue: false },
  lng: LANGUAGE_CODE[localStorage.getItem('currentLanguage') ?? 0]
});

export default i18n;
